import axiosInstance from "../../api/axiosInstance";

export const fetchAdminActionLogsAPI = async ({
  page = 1,
  limit = 20,
  actorAdminId = "",
  tournamentId = "",
  action = "",
  status = "",
} = {}) => {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("limit", String(limit));
  if (actorAdminId) params.set("actorAdminId", String(actorAdminId));
  if (tournamentId) params.set("tournamentId", String(tournamentId));
  if (action) params.set("action", String(action));
  if (status) params.set("status", String(status));

  const response = await axiosInstance.get(`admins/action-logs?${params.toString()}`);
  return response.data;
};

export const fetchAdminActionTypesAPI = async () => {
  const response = await axiosInstance.get("admins/action-types");
  return response.data;
};

export const fetchAdminActionAdminsAPI = async () => {
  const response = await axiosInstance.get("admins/action-log-admins");
  return response.data;
};

export const fetchAdminActionTournamentsAPI = async ({
  page = 1,
  limit = 10,
  q = "",
} = {}) => {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("limit", String(limit));
  if (q) params.set("q", String(q));

  const response = await axiosInstance.get(
    `admins/action-log-tournaments?${params.toString()}`,
  );
  return response.data;
};

export const fetchAdminActionTargetDetailsAPI = async ({
  action,
  targetId,
  logId,
}) => {
  const params = new URLSearchParams();
  params.set("action", String(action || ""));
  params.set("targetId", String(targetId || ""));
  if (logId) params.set("logId", String(logId));

  const response = await axiosInstance.get(
    `admins/action-target-details?${params.toString()}`,
  );
  return response.data;
};
